import React, { } from 'react'
import { Form, Input, InputNumber, Select } from 'antd'
import { useTranslation } from 'react-i18next'
import { QueryExpression } from '../../../constants/DashboardConf'

const { COUNT, AVG, SUM } = QueryExpression
function SummarySetting (props) {
  const { defPlaceholder, defConfig, schema } = props
  const { t: ln_t } = useTranslation()

  const aggregateOptions = [{ value: SUM, label: ln_t('dashboard.sum') }, { value: AVG, label: ln_t('dashboard.avg') }, { value: COUNT, label: ln_t('dashboard.count') }]

  return (
    <>
      <Form.Item {...defConfig('column', 'select')}>
        <Select showSearch placeholder={defPlaceholder('column', 'select')} options={schema} optionFilterProp="children" />
      </Form.Item>
      <Form.Item {...defConfig('aggregate', 'select')}>
        <Select showSearch placeholder={defPlaceholder('aggregate', 'select')} options={aggregateOptions} optionFilterProp="children" />
      </Form.Item>
      <Form.Item {...defConfig('decimal', 'input', false)}>
        <InputNumber placeholder={defPlaceholder('decimal', 'input')} precision={0} min={1} max={5} style={{ width: '100%' }} />
      </Form.Item>
      <Form.Item {...defConfig('prefix', 'input', false)}>
        <Input placeholder={defPlaceholder('prefix', 'input')} />
      </Form.Item>
      <Form.Item {...defConfig('suffix', 'input', false)}>
        <Input placeholder={defPlaceholder('suffix', 'input')} />
      </Form.Item>
    </>
  )
}

export default SummarySetting
